import { pxToRem } from '../../../scripts/lib/px-to-rem';

const closeButton = document.getElementById('close-banner-button');
const reciteMeButton = document.querySelector('.c-recite-me__button');
const messengerButton = document.querySelector('.c-facebook-messenger__button');

const mutationObserver = new MutationObserver((mutations, observer) => {
  for (const mutation of mutations) {
    const addedNodes = [...mutation.addedNodes];
    const otButton = addedNodes.find((node) => node.id === 'onetrust-consent-sdk');

    // We have found the OT button. Want to exit the loop
    if (otButton) {
      onWindowResized();
      // disconnect as we have found our mutation
      observer.disconnect();
      return;
    }
  }
});

mutationObserver.observe(document.body, { childList: true, subtree: true });

// SSENDPO-514 (https://jira.mandogroup.com/browse/SSENDPO-514)
// Following a discussion with Alex H and Abs the decision is to hide this component when the site is rendered in viewports less that 980px.
// There will be an enhancement delivered in a future sprint for lower resolution viewports.
const padding = 16;
const largeBreakpoint = 980;

/** Closes the banner and resets the messenger and recite me buttons to their proper positions */
function onBannerClosed() {
  const floatingBanner = document.getElementById('floating-cta-banner');
  floatingBanner.remove();

  resetFixedButtons();
}

/* Gets the height offset needed for the recite me bottom height
 * @returns number
 * **/
function getOneTrustShieldOffset() {
  const otShieldButton = document.querySelector('.ot-floating-button');
  if (!otShieldButton) {
    return 0;
  }
  // Recite me button and OT button are the same height. On local dev, OT button is huge, so use this as failsafe
  return reciteMeButton.getBoundingClientRect().height + padding;
}

/** Fires each time the window is resized */
function onWindowResized() {
  const otShieldButton = document.querySelector('.ot-floating-button');
  const floatingBanner = document.getElementById('floating-cta-banner');

  // Floating banner isn't here. No need to run the rest of the function.
  if (!floatingBanner) return;

  // Can't reset buttons if they don't exist
  if (!reciteMeButton || !messengerButton) {
    return;
  }

  // Window is smaller than the break point, or the floating banner has been dismissed. Reset button position.
  if (window.innerWidth < largeBreakpoint) {
    resetFixedButtons();
    return;
  }

  // Get the height of the banner
  const { height } = floatingBanner.getBoundingClientRect();
  const otShieldOffset = getOneTrustShieldOffset();

  const offset = height + padding;

  // Update the bottom of each button to have some padding between the floating CTA footer
  // One Trust Button sits below the Recite Me Button. So add the offset to it.
  reciteMeButton.style.bottom = pxToRem(offset + otShieldOffset);
  messengerButton.style.bottom = pxToRem(offset);

  if (!otShieldButton) return;
  otShieldButton.style.bottom = pxToRem(offset);
}

/** Resets the buttons to the correct position */
function resetFixedButtons() {
  const otShieldButton = document.querySelector('.ot-floating-button');
  reciteMeButton.style.bottom = '';
  messengerButton.style.bottom = '';

  if (!otShieldButton) return;
  otShieldButton.style.bottom = '';
}

function init() {
  if (!closeButton) return;
  closeButton.addEventListener('click', onBannerClosed);

  // Trigger initial resize to set button up as needed.
  onWindowResized();
  window.addEventListener('resize', onWindowResized);
}

export default init;
